module.exports = "<app-view-trip-route></app-view-trip-route>"


//////////////////
// WEBPACK FOOTER
// ./src/app/user-dashboard/view-route-dialog/view-route-dialog.component.html
// module id = ./src/app/user-dashboard/view-route-dialog/view-route-dialog.component.html
// module chunks = main